import useSWRImmutable from "swr/immutable";

const baseUrl = process.env.REACT_APP_BASE_URL;

const fetcher = (...args) => fetch(...args).then((res) => res.json());
export function useFetch(url = "") {
	const { data, error, isLoading } = useSWRImmutable(
		`${baseUrl}${url}`,
		fetcher
	);

	return {
		data: data,
		isLoading,
		isError: error,
	};
}
